import { type UIMessage } from "../ai-sdk/ui-message.ts";

/** Tool types that require user interaction and should remain enabled. */
const INTERACTIVE_TOOL_TYPES = new Set(["tool-askUser", "tool-askUserCards"]);

/**
 * Find an interactive (user-facing) tool call ID in the **last message** only.
 * The AI cannot continue past a tool-askUser/tool-askUserCards without user
 * input, so if messages exist after the one containing the tool it has already
 * been answered and should not re-render. Returns undefined if the last message
 * contains no interactive tool call.
 */
export const findLatestToolCallId = (
  messages: Iterable<UIMessage>,
): string | undefined => {
  const messagesArray = Array.from(messages);
  const lastMessage = messagesArray[messagesArray.length - 1];
  if (!lastMessage) return undefined;

  for (let j = lastMessage.parts.length - 1; j >= 0; j--) {
    const part = lastMessage.parts[j];
    if (INTERACTIVE_TOOL_TYPES.has(part.type) && "toolCallId" in part) {
      return part.toolCallId;
    }
  }
  return undefined;
};
